function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgTip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#E3DEC9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0001 5.23916V4.54089M18.7491 12H18.0509M5.22168 12H5.91995M6.30908 7.58896L6.80283 8.08271M17.2089 8.08271L17.7027 7.58896M6.86482 15.7375L7.35857 15.2438M17.1354 15.7375L16.6417 15.2438",
  stroke: "#1B1B1B",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 7.04437C9.70629 7.04437 7.85254 8.94729 7.85254 11.3043C7.85254 13.4667 9.86339 15.0993 10.0519 15.294C10.7012 15.9643 9.99954 18.8944 10.8583 18.8944H13.1415C14.0003 18.8944 13.2986 15.9643 13.9479 15.294C14.1364 15.0993 16.1473 13.4667 16.1473 11.3043C16.1473 8.94729 14.2935 7.04437 11.9999 7.04437Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2754 15.7841H13.7244M11.9999 7.04437C9.70629 7.04437 7.85254 8.94729 7.85254 11.3043C7.85254 13.4667 9.86339 15.0993 10.0519 15.294C10.7012 15.9643 9.99954 18.8944 10.8583 18.8944H13.1415C14.0003 18.8944 13.2986 15.9643 13.9479 15.294C14.1364 15.0993 16.1473 13.4667 16.1473 11.3043C16.1473 8.94729 14.2935 7.04437 11.9999 7.04437Z",
  stroke: "#1B1B1B",
  strokeWidth: 2
}));
export default SvgTip;